import PropTypes from "prop-types";

import { FilterContainer } from "./Filter.styles";

// Filtered timeframe to match Figma design
const FILTERED_TIME_FRAME = [
  { id: "1d", title: "1D" },
  { id: "1w", title: "1W" },
  { id: "1m", title: "1M" },
  { id: "1y", title: "1Y" },
  { id: "all", title: "All" },
];

const Filter = ({
  timeframe = FILTERED_TIME_FRAME,
  activePeriod,
  handleFilterClick,
  className,
}) => {
  return (
    <FilterContainer className={className}>
      <ul>
        {timeframe.map((period) => {
          const key = period.id !== undefined ? period.id : period;
          return (
            <li
              className={
                period.id === activePeriod || period == activePeriod
                  ? "active"
                  : ""
              }
              key={key}
              onClick={() => handleFilterClick(key)}
            >
              {period.title || period}
            </li>
          );
        })}
      </ul>
    </FilterContainer>
  );
};

Filter.propTypes = {
  activePeriod: PropTypes.string,
  handleFilterClick: PropTypes.func,
  className: PropTypes.string,
  timeframe: PropTypes.array,
};

export { Filter };
